import { useEffect, useRef } from "react";
import { CommonPage, Content, PageTitle } from "common/Grid";
import { toast } from "react-toastify";
import { SalesUserForm } from "../Common/MainForm";
import { useCreateSalesUserMutation } from "store/action/salesUserApi";
import { useNavigate } from "react-router-dom";
import { captureComponentError } from "utils/sentry";

const CreateSalesUser = () => {
  const [createSalesUser, { isLoading }] = useCreateSalesUserMutation();
  const navigate = useNavigate();
  const successRef = useRef(false);

  useEffect(() => {
    return () => {
      if (!successRef.current) {
        toast.dismiss();
      }
    };
  }, []);

  const handleSubmit = async (userInput) => {
    try {
      const response = await createSalesUser({ body: userInput }).unwrap();
      successRef.current = true;
      toast.success(response?.message || "Sales user created successfully");
      navigate("/sales-user");
    } catch (error) {
      toast.error(error?.data?.message || "Something went wrong!");
      captureComponentError(error, { component: "CreateSalesUser", action: "handleSubmit" });
    }
  };

  return (
    <CommonPage>
      <Content>
        <PageTitle title="Create Sales User" />
        <SalesUserForm onSubmit={handleSubmit} isLoading={isLoading} />
      </Content>
    </CommonPage>
  );
};

export default CreateSalesUser;
